import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getStringFromStorage } from '../services/storageService';
import { paths } from './routesConfig';
import { isAuthenticated } from '../services/authService';

function ProtectedRoutes() {
  const tenant = getStringFromStorage('tenant');
  if (isAuthenticated()) return <Outlet />;

  return <Navigate to={`${paths.login}${tenant && '?tenant_code=' + tenant}`} replace />;
}

export default ProtectedRoutes;
